import { fetchApi } from "../fetchApi";

export async function onApplyPromoCode({
  sale_order_id = false,
  coupon = "",
  token = null,
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: { sale_order_id, coupon, token },
  });

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    credentials: "include",
  };

  const endpoint = "/mini-store/coupon";

  let response = await fetchApi({ requestOptions, endpoint });
  response = await JSON.parse(response);

  if (response && response.result) {
    return response.result; // This will contain payment transaction data
  } else {
    throw new Error("Invalid response structure");
  }
}
